<template>
  <div id="userAll">
    <div class="classify">
      <div class="left">
        <span class="status">状态：</span>
        <span
          @click="setStatusAct(0, null)"
          :class="statusAct === 0 ? 'act' : 'statusList'"
          >全部</span
        >
        <!--        <span-->
        <!--          @click="setStatusAct(1, '已审核')"-->
        <!--          :class="statusAct === 1 ? 'act' : 'statusList'"-->
        <!--        >已审核</span-->
        <!--        >-->
        <span
          @click="setStatusAct(1, 1)"
          :class="statusAct === 1 ? 'act' : 'statusList'"
          >已发布</span
        >
        <span
          @click="setStatusAct(2, 2)"
          :class="statusAct === 2 ? 'act' : 'statusList'"
          >审核中</span
        >
        <span
          @click="setStatusAct(3, 3)"
          :class="statusAct === 3 ? 'act' : 'statusList'"
          >未通过</span
        >
        <span
          @click="setStatusAct(4, 4)"
          :class="statusAct === 4 ? 'act' : 'statusList'"
          >已下架</span
        >
        <span
          @click="setStatusAct(5, 5)"
          :class="statusAct === 5 ? 'act' : 'statusList'"
          >草稿</span
        >
      </div>
      <div class="right">
        <span class="time">时间：</span>
        <DatePicker
          :value="value2"
          format="yyyy/MM/dd"
          @on-change="handleChange"
          type="daterange"
          placement="bottom-end"
          placeholder="Select date"
          style="width: 220px"
        ></DatePicker>
        <Input
          v-model="search"
          placeholder="请输入标题进行搜索"
          class="searchinput"
        >
          <Icon @click="handleClick" type="ios-search" slot="suffix" />
        </Input>
        <input type="text" style="opacity: 0; width: 0" />
      </div>
    </div>
    <div class="classify">
      <div class="left">
        <span class="status">属性：</span>
        <span
          @click="setSropertyAct(0, '0')"
          :class="property === '0' ? 'act' : 'statusList'"
          >全部</span
        >
        <span
          @click="setSropertyAct(1, '1')"
          :class="property === '1' ? 'act' : 'statusList'"
          >{{
            isSonUser === "true"
              ? userInfo.user.subType === 1
                ? "百科号"
                : "机构号"
              : userInfo.user.customerType === 1 ||
                userInfo.user.customerType === 2
              ? "百家号"
              : userInfo.user.customerType === 4
              ? "百科号"
              : "机构号"
          }}</span
        >
        <span
          v-for="item in scienceList"
          :key="item.channel1Id"
          @click="setSropertyAct(0, item.channel1Id)"
          :class="property === item.channel1Id ? 'act' : 'statusList'"
          >{{ item.channel2Name ? item.channel2Name : item.channel1Name }}</span
        >
      </div>
    </div>
    <div class="list">
      <div class="box" v-for="item in list" :key="item.articleId">
        <div class="left">
          <div class="msg">
            <!-- <div
              class="top"
              v-if="item.status !== 2 || item.auditStatus === 0"
            > -->
            <div class="top"  v-if="item.status !== 2">
              <span :class="item.auditStatus | colored">{{
                item.auditStatus | type
              }}</span
              ><span></span>
              <span v-html="item.title"></span>
            </div>
            <div
              class="top"
              v-else
            >
              <span class="down">已下架</span><span></span>
              <span v-html="item.title"></span>
            </div>
            <div
              class="author"
              :style="{ marginTop: item.auditStatus === 0 ? '63px' : '35px' }"
            >
              <span v-if="item.mettingName"> {{ item.mettingName }} -</span>
              <span v-if="item.authorList"> {{ item.authorList }} -</span>
              <!-- <span v-if="item.mettingTime"> {{ item.mettingTime }}</span> -->
              <span v-if="item.articleType === 2 && item.mettingTime"> {{ item.mettingTime | formatTime }}</span>
              <span v-if="item.articleType !== 2 && item.mettingTime"> {{ item.mettingTime }}</span>
            </div>
            <div
              v-if="item.auditStatus === 3"
              class="read"
            >
              <span class="key">原因：<span class="value1">{{ item.opinion }}</span></span>
            </div>
            <template v-else>
              <div
                v-if="item.auditStatus === 2"
                class="read"
              >
                <span class="key"
                  >阅读量：<span class="value">{{ item.readPv }}</span></span
                ><span class="key"
                  >收藏量：<span class="value">{{ item.collectPv }}</span></span
                ><span class="key"
                  >分享量：<span class="value">{{ item.sharePv }}</span></span
                >
              </div>
            </template>
          </div>
        </div>
        <div class="right">
          <div class="time">{{ item.createTime }}</div>
          <!-- <div class="edit" v-if="item.status !== 2 || item.auditStatus === 0"> -->
          <div class="edit" v-if="item.status !== 2">
            <template v-if="item.auditStatus === 2">
              <span class="blue" @click="openDrawer(item)">详细信息</span>
              <Tooltip
                @on-popper-show="ToolTipShow(item)"
                content="Bottom Center text"
                theme="light"
              >
                <span class="blue">申请发布栏目</span>
                <div slot="content">
                  <div class="title" v-if="ShowList.length === 0">中文知识网</div>
                  <div class="title" v-else v-for="obj in ShowList" :key="obj.articleId">
                    {{ obj.name }}
                    <div
                      :class="sObj.status === 2 ? 'blue' : 'black'"
                      v-for="(sObj,index) in obj.childList"
                      :key="index"
                      @click="setStatus(item, obj, sObj)"
                    >
                      {{ sObj.status | please }}{{ sObj.channelName }}
                    </div>
                  </div>
                </div>
              </Tooltip>
              <span @click="asyncFamilies(item)" :class="item.syncStatus === 0 ? 'black' : 'blue'">
                {{ item.syncStatus === 0 ? `已同步至${columnNum}` : `同步至${columnNum}` }}
              </span>
              <!-- <span class="blue" @click="edit(item)" v-if="item.articleType !== 6">修改</span> -->
              <span v-if="userInfo.user.customerType === 2" class="blue" @click="giveUp(item)">退领</span>
              <span class="black" v-else>删除</span>
            </template>
            <template v-if="item.auditStatus === 0"
              ><span class="black">修改</span
              ><span class="black">删除</span></template
            >
            <template v-if="item.auditStatus === 3"
              ><span class="blue" @click="edit(item)">修改</span
              ><span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 1"
              ><span class="blue" @click="edit(item)">修改</span
              ><span class="blue" @click="del(item)">删除</span></template
            >
          </div>
          <div class="edit" v-else>
            <!-- <span class="black" v-if="item.articleType === 6">修改</span>
            <span class="blue" @click="edit(item)" v-else>修改</span> -->
            <span class="black">修改</span>
            <span class="black" @click="del(item)">删除</span>
          </div>
        </div>
      </div>
      <Spin fix v-if="spinShow">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>加载中...</div>
      </Spin>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Drawer :mask-closable="false" width="769" v-model="detailsShow">
      <DrawerDetail v-if="detailsShow" :articleId="drawerId" :articleType="drawerType"/>
    </Drawer>
  </div>
</template>

<script>
import Paging from "@/components/paging/index.vue";
import DrawerDetail from "./drawerDetail.vue";
import { mapState } from "vuex";

export default {
  name: "all",
  computed: {
    isSonUser() {
      return sessionStorage.getItem("isSon");
    },
    ...mapState(["userInfo"]),
    columnNum() {
      let str = "";
      if (sessionStorage.getItem("isSon") === "false") {
        if (this.userInfo.user.customerType === 4) {
          str = "百科号";
        } else if (this.userInfo.user.customerType === 5) {
          str = "机构号";
        } else if (
          this.userInfo.user.customerType === 1 ||
          this.userInfo.user.customerType === 2
        ) {
          str = "百家号";
        }
      } else {
        if (this.userInfo.user.subType === 1) {
          str = "百科号";
        } else if (this.userInfo.user.subType === 2) {
          str = "机构号";
        }
      }
      return str;
    },
  },
  components: { Paging,DrawerDetail },
  data() {
    return {
      requestLoding: false,
      value2: [null, null],
      search: null,
      statusAct: 0,
      property: '0',
      page: 1,
      list: [],
      status: null,
      total: 0,
      scienceList: [],
      // 学术专著
      monographList: [],
      synchronizationStatus: 0,
      projectId: null,
      channel1Id: null,
      channel2Id: null,
      ShowList: [],
      spinShow: false,
      detailsShow: false,
      drawerId: '',
      drawerType: '',
    };
  },
  filters: {
    type: function (num) {
      if (num === 2) {
        return "已发布";
      } else if (num === 0) {
        return "审核中";
      } else if (num === 3) {
        return "未通过";
      } else if (num === 1) {
        return "草稿";
      }
    },
    colored: function (num) {
      if (num === 2) {
        return "send";
      } else if (num === 0) {
        return "ing";
      } else if (num === 3) {
        return "pass";
      } else if (num === 1) {
        return "edit";
      }
    },
    please: function (num) {
      if (num === 0) {
        return "已申请";
      } else if (num === 1) {
        return "已发布";
      } else if (num === 2) {
        return "申请";
      }
    },
    formatTime: function(query) {
      let arr = query.split('-')
      return `${arr[0]}年${arr[1]}月`
    }
  },
  created() {
    this.getList();
    this.getScience();
  },
  methods: {
    // 打开详细信息抽屉
    openDrawer(e) {
      this.detailsShow = true
      this.drawerId = e.articleId
      this.drawerType = e.articleType
    },
    edit(e) {
      let { type, articleType, articleId } = e;
      if (type === 0 && articleType === 5) {
        this.$router.push(`/informationForm?id=${articleId}&title=资讯`);
      } else if (type === 0 && articleType === 0) {
        this.$router.push(`/paperForm?id=${articleId}&title=论文`);
      } else if (type === 0 && articleType === 3) {
        this.$router.push(`/abstractForm?id=${articleId}&title=文摘`);
      } else if (articleType === 6) {
        this.$router.push(`/reportForm?id=${articleId}&title=报告`);
      } else if (articleType === 2) {
        this.$router.push(`/monographForm?id=${articleId}&title=专著`);
      }
    },
    async exit(e) {
      console.log(e);
      let obj = {
        articleId: e.articleId,
        articleType: e.articleType,
      };
      console.log(obj);
      const res = await this.$apis.userServe.downId(obj);
      if (res) {
        await this.getList();
      }
    },
    async setStatus(item, obj, sobj) {
      if (sobj.status !== 2) return
      // console.log(item, obj, sobj);
      let resObj = {
        articleId: item.articleId,
        articleType: item.articleType,
        projectId: obj.projectId,
        channelId1: sobj.channelId1 ? sobj.channelId1 : null,
        channelId2: sobj.channelId2 ? sobj.channelId2 : null,
      };
      const res = await this.$apis.userServe.setStatus(resObj);
      if (res) {
        await this.ToolTipShow(item);
      }
    },
    async ToolTipShow(e) {
      const obj = {
        articleId: e.articleId,
        articleType: e.articleType,
      };
      const { data } = await this.$apis.userServe.apply(obj);
      this.ShowList = data;
      const Tabel = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      this.ShowList.map((e) => {
        Tabel.forEach((item) => {
          if (e.projectId === item.id) {
            e["name"] = item.name;
          }
        });
      });
    },
    async asyncFamilies(e) {
      if (this.requestLoding) return;
      if (e.syncStatus === 0) {
        // 撤回同步
        const obj = {
          articleId: e.articleId,
          articleType: e.articleType,
        };
        this.requestLoding = true;
        const { resultCode } = await this.$apis.userServe.withdraw(obj);
        if (resultCode === "200") {
          this.$Message.success("已取消同步");
          await this.getList();
        }
        this.requestLoding = false;
      } else {
        // 同步到XXX
        const obj = {
          articleId: e.articleId,
          articleType: e.articleType,
          title: e.title,
        };
        this.requestLoding = true;
        const { resultCode } = await this.$apis.userServe.asyncFamilies(obj);
        if (resultCode === "200") {
          this.$Message.success("已同步");
          await this.getList();
        }
        this.requestLoding = false;
      }
    },
    // 文献删除
    del(e) {
      this.$Modal.confirm({
        title: '操作确认',
        content: `<p>是否删除<<span>${e.title}</span>>?删除后无法恢复</p>`,
        onOk: async () => {
          const obj = {
            articleId: e.articleId,
            articleType: e.articleType,
            auditStatus: e.auditStatus,
          };
          const res = await this.$apis.userServe.delId(obj);
          if (res.resultCode === '200') {
            this.$Message.success('删除成功')
            this.getList()
          } else {
            this.$Message.error('删除失败')
          }
        },
        onCancel: () => {
          this.$Message.info('已取消删除操作');
        }
      });
    },
    // 文献退领
    giveUp(e) {
      this.$Modal.confirm({
        title: '操作确认',
        content: `<p>是否退领<<span>${e.title}</span>>?</p>`,
        onOk: async () => {
          const res = await this.$apis.userServe.withdrawalArticle({
            articleId: e.articleId,
            articleType: e.articleType,
          });
          if (res.resultCode === '200') {
            this.$Message.success('退领成功')
            this.getList()
          } else {
            this.$Message.error('退领失败')
          }
        },
        onCancel: () => {
          this.$Message.info('已取消退领操作');
        }
      });
    },
    // async donw(e) {
    //   console.log(e);
    //   let obj = {
    //     articleId: e.articleId,
    //     articleType: 5,
    //   };
    //   console.log(obj);
    //   const res = await this.$apis.userServe.downId(obj);
    //   if (res) {
    //     await this.getList();
    //   }
    // },

    // 检索功能
    setSropertyAct(i, type) {
      this.page = 1;
      this.property = type;
      this.synchronizationStatus = i
      this.channel1Id = type === '0' || type === '1' ? null : type
      this.projectId = type === '0' || type === '1' ? null : 1
      this.getList();
    },

    async getScience() {
      let {data: res1} = await this.$apis.userServe.science();
      this.scienceList = [...res1]
      if (
        (this.isSonUser === 'false' && this.userInfo.user.customerType !== 4) || //当为主账号并且不是期刊类型账号
        (this.isSonUser === 'true' && this.userInfo.user.subType === 2) // 当为子账号并且属于机构子账号
      ) {
        let {data: res2} = await this.$apis.userServe.monograph(4);
        let {data: res3} = await this.$apis.userServe.monograph(3);
        this.scienceList.push(...res2,...res3)
      }
    },
    handlePager(e) {
      this.page = e;
      this.getList();
    },
    handleClick() {
      this.page = 1;
      this.getList();
    },
    handleChange(value) {
      console.log(value);
      this.page = 1;
      this.getList();
    },
    setStatusAct(i, status) {
      console.log("all setStatusAct", i, status);
      this.statusAct = i;
      this.status = status;
      this.page = 1;
      this.getList();
    },
    async getList() {
      this.spinShow = true
      let obj = {
        pageNo: this.page,
        pageSize: 10,
        title: this.search,
        beginTime: this.value2[0],
        endTime: this.value2[1],
        status: this.status,
        synchronizationStatus: this.synchronizationStatus,
        projectId: this.projectId,
        channel1Id: this.channel1Id,
      };
      const { data } = await this.$apis.userServe.getUserContentMrgList(obj);
      this.spinShow = false
      let { total } = data;
      this.total = Number(total);
      this.list = data.list;
      // this.reset()
    },
    // 参数重置
    reset(){
      this.page = 1
      this.search = null
      this.value2 = [null, null]
      this.status = null
      this.synchronizationStatus = 0
      this.projectId = null
      this.channel1Id = null
    }
  },
};
</script>

<style lang="scss" scoped>
#userAll {
  padding-top: 30px;
  //background: yellow;
  width: 1200px;
  //height: 300px;
  .list {
    position: relative;
    margin-top: 30px;
    min-height: 500px;
    
    .demo-spin-icon-load{
        animation: ani-demo-spin 1s linear infinite;
    }

    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 45px;
      min-height: 150px;
      background: #fff;
      box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
      // .left{
      //   .read{
      //     overflow : hidden;
      //     text-overflow: ellipsis;
      //     display: -webkit-box;
      //     -webkit-line-clamp: 2;
      //     -webkit-box-orient: vertical;
      //   }
      // }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // width: 300px;
        .time {
          font-size: 12px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #666666;
          text-align: right;
        }

        .edit {
          text-align: right;
          span {
            margin-left: 25px;
            cursor: pointer;
          }
          span:nth-child(2) {
            width: 140px !important;
          }

          .title {
            margin-bottom: 20px;
            font-size: 14px;
            width: 100px;
            //font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 24px;
            color: #333333;
            cursor: pointer;

            .blue {
              //height: 24px;
              font-size: 12px;
              line-height: 24px;
              //font-family: Microsoft YaHei;
              font-weight: 400;
              color: #183ed7;
            }

            .black {
              //height: 13px;
              font-size: 12px;
              line-height: 24px;
              //font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
          }

          .blue {
            color: rgba(11, 53, 197, 1);
          }

          .black {
            color: #999999;
          }
        }
      }

      .left {
        display: flex;
        width: 500px;

        img {
          width: 122px;
          height: 122px;
        }

        .msg {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          font-size: 14px;
          .top {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &::v-deep p {
              display: inline-block !important;
            }
            .edit {
              color: #ff9415;
              margin-right: 10px;
            }

            .edit + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff9415;
              display: inline-block;
            }

            .send {
              color: #10286f;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .send + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #10286f;
              display: inline-block;
            }

            .ing {
              color: #8073d2;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .ing + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #8073d2;
              display: inline-block;
            }

            .pass {
              color: #ff0000;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .pass + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #ff0000;
              display: inline-block;
            }

            .down {
              color: #dc727c;
              margin-right: 10px;
              //display: inline-block;
              //border-right: #FF9415 1px solid;
              //padding-right: 10px;
              //height: 20px;
            }

            .down + span {
              margin-bottom: -2px;
              margin-right: 10px;
              width: 2px;
              height: 15px;
              background: #dc727c;
              display: inline-block;
            }
          }

          .author {
            color: #666666;
            font-size: 14px;
            font-weight: 400;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .read {
            margin-top: 10px;
            width: 100%;
            .key {
              word-break: break-all;
              margin-right: 25px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
            }
          }
        }
      }
    }
  }

  .classify {
    display: flex;
    height: 30px;
    justify-content: space-between;
    width: 100%;

    .right {
      height: 30px;

      .time {
        //background: yellow;
        line-height: 30px;
        margin-right: 10px;
      }

      .searchinput {
        width: 351px;
        //height: 41px;
        border-radius: 10px;
        margin-left: 33px;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      cursor: pointer;

      .status {
        margin-right: 3px;
      }

      .statusList {
        margin-left: 10px;
        margin-right: 10px;
      }

      .act {
        margin-left: 10px;
        margin-right: 10px;
        color: #0101f3;
      }
    }
  }
}
::v-deep .ivu-drawer-close {
  top: 0;
  right: 0;
  left: 0;
  width: 36px;
  height: 36px;
  border-radius: 0 0 36px 0;
  background-color: rgba(55,55,55,.6);
  .ivu-icon-ios-close {
    top: -2px;
    left: -2px;
    font-size: 34px;
    color: #fff;
  }
}
</style>
